import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';

// Dev-only auth bypass. Active ONLY when both:
//   - VITE_AUTH_BYPASS=1   (set in .env.local for local dev)
//   - import.meta.env.DEV  (true during `vite dev`, false in production builds)
// The second guard makes the bypass impossible to ship to production even if
// someone forgets to flip the env var. Paired with admin-proxy AUTH_BYPASS=1
// which accepts X-Dev-Email header instead of a JWT.
const AUTH_BYPASS = import.meta.env.VITE_AUTH_BYPASS === '1' && import.meta.env.DEV;

if (AUTH_BYPASS) {
  // eslint-disable-next-line no-console
  console.warn(
    '[AuthGuard] AUTH_BYPASS=1 — Firebase login is being skipped. Dev only.'
  );
}

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }: GuardProps) {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (AUTH_BYPASS) return;
    if (!isLoggedIn && location.pathname !== '/login') {
      navigate('login', {
        state: {
          from: location.pathname
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location]);

  return children;
}
